export const STATUSES = {
  // --- Statuses that come from the Excel extractions ---
  a_prendre_en_charge: {
    label: "À prendre en charge",
    short: "À prendre en charge",
    color: "#F59E0B",
    chip: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    group: "excel",
  },
  planifie_non_transmis: {
    label: "Planifié non transmis",
    short: "Planifié non transmis",
    color: "#3B82F6",
    chip: "bg-blue-500/15 text-blue-400 border-blue-500/30",
    group: "excel",
  },
  transmis: {
    label: "Transmis",
    short: "Transmis",
    color: "#06B6D4",
    chip: "bg-cyan-500/15 text-cyan-400 border-cyan-500/30",
    group: "excel",
  },
  termine: {
    label: "Terminé",
    short: "Terminé",
    color: "#10B981",
    chip: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    group: "excel",
  },
  // --- App-only statuses (set inside the app, not from Excel) ---
  a_planifier: {
    label: "À planifier",
    short: "À planifier",
    color: "#A855F7",
    chip: "bg-purple-500/15 text-purple-400 border-purple-500/30",
    group: "app",
  },
  planifier: {
    label: "Planifier",
    short: "Planifier",
    color: "#EC4899",
    chip: "bg-pink-500/15 text-pink-400 border-pink-500/30",
    group: "app",
  },
};

export const EXCEL_STATUSES = ["a_prendre_en_charge", "planifie_non_transmis", "transmis", "termine"];
export const APP_STATUSES = ["a_planifier", "planifier"];
export const STATUS_ORDER = [...EXCEL_STATUSES, ...APP_STATUSES];

// bottom -> top order for the cluster gauge fill
export const GAUGE_ORDER = ["termine", "transmis", "planifie_non_transmis", "a_prendre_en_charge", "a_planifier", "planifier"];

export const statusInfo = (k) => STATUSES[k] || STATUSES.a_prendre_en_charge;
